<template>
  <div class="page">
    <section style="position: fixed; left:0; top:0;z-index:99;width: 100%;">
      <div class="navbar">
        <div class="back" @click="$router.go(-1)"></div>
        <div class="search">
          <input type="text" autofocus="autofocus" v-focus v-model="keyword" :placeholder="placeholder" @keyup.enter="search" />
        </div>
        <div class="searchBtn" @click="search">搜索</div>
      </div>

      <div class="filter" v-if="list.length != 0">
        <!-- <div class="filter-select">
          <div class="item" :class="item.title == filter ?'active' : ''" v-for="(item, index) in filterConfig" :key="index" @click="changeFilt(item)">
            {{item.title}}
            <img src="../assets/icon_price.png" style="width: 0.06rem" />
          </div>
        </div> -->
        <van-dropdown-menu>
          <van-dropdown-item v-model="sort" :options="option2" @change="toSort" />
        </van-dropdown-menu>
        <div class="filter-type" ref="mbType" @click.stop="openType">
          分类<img src="../assets/icon_type.png" style="width: 0.1rem;margin-left: 0.05rem;" />

          <div class="typeBox" v-show="typeFlag">
            <div class="typeBox-item" :class="active == item.product_category_id ? 'typeBox_active' : ''" v-for="(item,index) in typeConfig" :key="index" @click="chooseType(item)">
              <img :src="require(`../assets/icon${item.id}.png`)" />
              <p>{{item.product_category}}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <template v-if="list.length == 0 && keyword == '' && keys.length != 0">
      <div class="wrap_hot">
        <h3>热门搜索</h3>
        <section class="box">
          <span v-for="(item, index) in keys" :key="index" @click="search_hot(item.name)">{{item.name}}</span>
        </section>
      </div>
    </template>

    <section style="padding-top: 1rem;">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="list.length != 0">
        <van-list class="shopList van-clearfix" v-model="loading" :finished="finished" finished-text="已经到底线了" :immediate-check="false" @load="loadmore">
          <div class="shopList-item" v-for="(item, index) in list" :key="index" @click="toDet(item)">
            <div class="pic">
              <img :src="item.goodsimg" />
            </div>
            <div class="info">
              <h3>{{item.goodsname}}</h3>
              <div class="price">
                <span>优选价:<strong>￥{{item.price}}</strong></span>
                <span>某东价:￥{{item.jdprice}}</span>
              </div>
              <!-- <div class="tags">
              <span v-for="tag in item.tags" :key="tag">{{tag}}</span>
            </div> -->
              <!-- <div class="state">
              <span>{{item.comments}}条评论</span>
              <span>{{item.score}}好评</span>
            </div> -->
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <template v-if="noData">
        <van-empty image="search" description="暂无数据" />
      </template>

    </section>

  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: '',
      filterConfig: [
        // {
        //   title: '综合推荐'
        // }, 
        {
          title: '价格'
        }
      ],
      filter: '综合推荐',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      typeConfig: [],
      typeFlag: false,
      page: 1,
      totalPages: 0,
      active: '',
      sort: '',
      option2: [
        { text: '价格排序', value: '' },
        { text: '价格最低', value: 'price-asc' },
        { text: '价格最高', value: 'price-desc' },
      ],
      placeholder: '',
      keys: [],
      noData: false
    }
  },
  watch: {
    keyword(val, oldVal) {
      console.log(val)
      if (val == '') {
        this.noData = false
        this.active = ''
      }
    }
  },
  created: function () {
    this.getFillter()
    this.getHotKey()
    if (this.$route.query.keyword) {
      this.placeholder = this.$route.query.keyword
    }
  },
  mounted: function () {

  },
  methods: {
    getData() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      let params = { p: this.page, kw: this.keyword, category: this.active, sort: this.sort }
      this.common.request({
        url: "Index",
        methods: "post",
        params: params,
        callback: res => {
          if (res.data.errcode == 0) {
            this.loading = false;
            this.banners = res.data.data.banner
            this.list = this.list.concat(res.data.data.data)
            if (this.list.length == 0) {
              this.noData = true
            } else {
              this.noData = false
            }
            this.totalPages = res.data.data.totalPages
            if (this.page >= this.totalPages) {
              this.finished = true
            }
          } else {
            this.finished = true;
            this.loading = false;
          }
        }
      })

    },
    loadmore() {
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        if (this.loading) {
          this.page = this.page + 1
          let params = { p: this.page, kw: this.keyword, category: this.active, sort: this.sort }
          this.common.request({
            url: "Index",
            methods: "post",
            params: params,
            callback: res => {
              if (res.data.errcode == 0) {
                this.loading = false;
                this.list = this.list.concat(res.data.data.data)
                this.totalPages = res.data.data.totalPages
                if (this.page >= this.totalPages) {
                  this.finished = true
                }
              } else {
                this.loading = false
                this.finished = true;
              }
            }
          })

          if (this.page >= this.totalPages) {
            this.finished = true;
          }
        }
      }, 1000);
    },
    getFillter() {
      this.common.request({
        url: 'Fillter',
        methods: 'get',
        params: {},
        callback: res => {
          console.log(res.data.data)
          this.typeConfig = res.data.data
        }
      })
    },
    getHotKey() {
      this.common.request({
        url: 'HotKW',
        methods: 'get',
        params: {},
        callback: res => {
          this.keys = res.data.data

        }
      })
    },
    search() {
      if (this.placeholder && !this.keyword) {
        this.keyword = this.placeholder
      }
      this.finished = false
      this.page = 1
      this.list = []
      this.sort = ''
      this.getData()

    },
    search_hot(item) {
      this.keyword = item
      this.finished = false
      this.page = 1
      this.list = []
      this.sort = ''
      this.getData()

    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.page = 1
      this.list = []
      this.loading = true;
      this.getData();
    },
    openType() {
      this.typeFlag = this.typeFlag ? false : true
    },
    changeFilt(item) {
      if (this.filter == '价格' && item.title == '价格') {
        this.getData()
      } else {
        this.filter = item.title
      }
    },
    chooseType(item) {
      this.finished = false
      this.active = item.product_category_id
      this.list = []
      this.page = 1
      // this.keyword = ''
      this.sort = ''
      this.getData()
    },
    toSort(value) {
      this.finished = false
      this.page = 1
      this.list = []
      this.sort = value
      this.getData()
    },
    toDet(item) {
      this.$router.push('/detail?id=' + item.id + '&allow_function_share')
    }
  },

}
</script>
<style>
.van-dropdown-menu__bar {
  box-shadow: none !important;
  background: none !important;
}
.van-dropdown-menu__title {
  font-size: 0.14rem;
  color: #666666;
}
</style>
<style lang="less" scoped>
.page {
  // min-height: 100vh;
  position: relative;
  .navbar {
    padding: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    max-width: 750px;
    margin: 0 auto;
    .back {
      width: 0.09rem;
      height: 0.3rem;
      background: url("../assets/icon_back.png") no-repeat;
      background-size: 0.09rem auto;
      background-position: left center;
      padding-right: 0.26rem;
    }
    .search {
      width: 100%;
      height: 0.3rem;
      background-color: #ededed;
      border-radius: 0.15rem;
      background-image: url("../assets/icon_search.png");
      background-size: 0.17rem auto;
      background-position: 0.1rem center;
      background-repeat: no-repeat;
      input {
        width: 100%;
        height: 100%;
        padding-left: 0.35rem;
        font-size: 0.14rem;
        color: #666666;
      }
    }
    .searchBtn {
      width: 0.68rem;
      height: 0.3rem;
      background-color: linear-gradient(90deg, #daae4d, #e5be62);
      background-image: url("../assets/btn_bg.png");
      background-size: 100% 100%;
      border-radius: 0.15rem;
      text-align: center;
      line-height: 0.3rem;
      font-size: 0.14rem;
      color: #fff;
      margin-left: 0.14rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .filter {
    width: 100%;
    max-width: 750px;
    height: 0.43rem;
    border-top: 0.01rem solid #f4f4f4;
    border-bottom: 0.01rem solid #f4f4f4;
    padding: 0 0.1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    margin: 0 auto;
    &-select {
      display: flex;
      height: 100%;
      align-items: center;
      & > .item {
        padding: 0 0.05rem;
        line-height: 0.45rem;
        font-size: 0.14rem;
        position: relative;
        color: #666666;
        margin-right: 0.3rem;
      }
      .active {
        color: #333;
        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 0.02rem;
          background-color: #ebd28e;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
    &-type {
      line-height: 0.45rem;
      font-size: 0.14rem;
      position: relative;
      color: #666666;
      .typeBox {
        position: absolute;
        right: 0;
        top: 0.6rem;
        min-width: 2.25rem;
        border-radius: 0.07rem;
        background-color: #fff;
        z-index: 9;
        box-shadow: 0 2px 12px rgb(50 50 51 / 12%);
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 0.1rem;
        transition: all 0.3s;
        &::before {
          content: "";
          display: block;
          width: 0.25rem;
          height: 0.21rem;
          background: url("../assets/arrow_top.png") no-repeat;
          background-size: 100% auto;
          position: absolute;
          right: 0.2rem;
          top: -0.18rem;
        }
        &-item {
          width: 50%;
          display: flex;
          align-items: center;
          img {
            width: 20%;
            margin-right: 0.1rem;
            flex-shrink: 0;
            height: 100%;
          }
          p {
            font-size: 0.14rem;
            color: #666666;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .shopList {
    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.14rem 0;
      margin: 0 0.1rem;
      border-bottom: 1px solid #f1f1f1;
      .pic {
        width: 1.05rem;
        height: 1.05rem;
        background: #e5e5e5;
        border-radius: 0.075rem;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .info {
        width: calc(100% - 1.2rem);
        h3 {
          font-size: 0.14rem;
          color: #333333;
          line-height: 0.21rem;
          display: -webkit-box;
          word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; // 需要显示的行数
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .price {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          padding-top: 0.2rem;
          span {
            &:first-child {
              font-size: 0.12rem;
              color: #c90827;
              strong {
                font-size: 0.16rem;
              }
            }
            &:last-child {
              font-size: 0.11rem;
              color: #999;
            }
          }
        }
        .tags {
          display: flex;
          align-items: center;
          margin-top: 0.08rem;
          span {
            background: linear-gradient(90deg, #daae4d, #e5be62);
            border-radius: 0.03rem;
            color: #fff;
            font-size: 0.12rem;
            padding: 0 0.08rem;
            margin-right: 0.07rem;
          }
        }
        .state {
          display: flex;
          align-items: center;
          margin-top: 0.08rem;
          span {
            font-size: 0.11rem;
            color: #999;
            &:first-child {
              padding-right: 0.06rem;
              position: relative;
              &::after {
                content: "";
                display: block;
                width: 0.01rem;
                height: 0.1rem;
                background-color: #999999;
                border-radius: 0.05rem;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
              }
            }
            &:nth-child(2) {
              padding-left: 0.06rem;
            }
          }
        }
      }
    }
  }

  .wrap_hot {
    padding: 0.65rem 0.15rem 0.15rem;
    background: #fff;
    h3 {
      font-size: 0.14rem;
      color: #333333;
    }
    .box {
      display: flex;
      flex-wrap: wrap;
      margin-top: 0.15rem;
      span {
        padding: 0.05rem 0.08rem;
        margin-right: 0.1rem;
        border-radius: 3px;
        margin-bottom: 0.1rem;
        color: #686868;
        background-color: #f0f2f5;
        box-sizing: border-box;
        font-size: 0.12rem;
      }
    }
  }
}
.typeBox_active {
  p {
    color: #e5be62 !important;
    position: relative;
    &::before {
      content: "";
      display: block;
      width: 0.2rem;
      height: 0.01rem;
      background-color: #ebd28e;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0.1rem;
    }
  }
}
</style>